import { render, staticRenderFns } from "./user-info-card.vue?vue&type=template&id=f1cc89de&scoped=true&"
import script from "./user-info-card.vue?vue&type=script&lang=ts&"
export * from "./user-info-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cc89de",
  null
  
)

export default component.exports